// SPDX-License-Identifier: MPL-2.0

/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

import { ClockIcon } from "@squidlab/phosphor-solid/clock";
import { REVEAL_OBJECT_CAPABILITY } from "../../lib/panel-capabilities";
import { definePanel } from "../../lib/panel-module";

export default definePanel({
  panelId: "panel-TimecodesPanel",
  componentName: "TimecodesPanel",
  title: "Timecodes",
  minWidth: 220,
  minHeight: 160,
  icon: ClockIcon,
  loadComponent: () => import("./panel"),
  capabilities: [REVEAL_OBJECT_CAPABILITY.id],
  showInPalette: true,
  singleton: "singleton",
});
